module.exports = __webpack_public_path__ + "img/qhse.004b672b.jpg";